import React from 'react';
import {
  AppBar,
  Box,
  Button,
  Toolbar, Typography, useTheme
} from '@mui/material';
import RoleBasedAccess from '../services/RoleBasedAccess';
import { useThemeContext } from '../context/ThemeContext';
import SpiderLogo from './SpiderLogo';
import NavbarActions from './NavbarActions';
import { useNavbarLogic } from '../hooks/navbar/useNavbarLogic';

const LoggedInNavbar: React.FC = () => {
  const theme = useTheme();
  const { handleNavigation } = useNavbarLogic();

  return (
    <AppBar position="fixed" /* ...sx styles */>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center">
          <SpiderLogo onClick={() => handleNavigation('/')} />
          <Typography variant="h6" color="text.primary" mx={3}>BWI</Typography>
          <RoleBasedAccess allowedRoles={["Internal", "Client"]}>
            <Button
              onClick={() => handleNavigation('/vehicles')}
              sx={{
                color: `${theme.palette.text.primary}`,
                fontSize: '14px',
                width: '100px',
                minHeight: '60px !important',
                marginX: '5px',
                '&:hover': { backgroundColor: theme.palette.action.hover },
              }}>
              Vehicles
            </Button>
          </RoleBasedAccess>
          <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
            <Button
              onClick={() => handleNavigation('/systems')}
              sx={{
                color: `${theme.palette.text.primary}`,
                fontSize: '14px',
                width: '100px',
                minHeight: '60px !important',
                marginX: '5px',
                '&:hover': { backgroundColor: theme.palette.action.hover },
              }}
            >
              Systems
            </Button>
          </RoleBasedAccess>
        </Box>
        <NavbarActions />
      </Toolbar>
    </AppBar>
  );
};

const LoggedOutNavbar: React.FC = () => {
  const { toggleDarkMode } = useThemeContext();
  return (
    <AppBar position="static" /* ...sx styles */>
      <Toolbar sx={{ justifyContent: 'center' }}>
        <SpiderLogo onClick={toggleDarkMode} />
      </Toolbar>
    </AppBar>
  );
};

const Navbar: React.FC = () => {
  const { isLoggedIn, isLogoutPage } = useNavbarLogic();

  if (!isLoggedIn || isLogoutPage) {
    return <LoggedOutNavbar />;
  }

  return <LoggedInNavbar />
};

export default Navbar;
